import React from "react";
import { connect } from 'react-redux';
import _ from 'lodash';

import Select from 'react-select';
import { Actions as TIMESHEET_IMPORT_ACTIONS } from '../../../store/actions/timesheetImportActions';
import { preview, timesheetFieldOptions } from './timesheetImportHelpers';

const TimesheetFieldMapping = ({
    fields,
    fieldMapping,
    setFieldMapping,
    previewData,
    setShowSettings,
    getImportMapping,
    saveFieldMapping,
    savingMappingStatus
}) => {

  const fieldsToShow = _.reject(fields,field => field.substring(0,1) == "@" );

  return (
    <div className="row"> 
        <div className="col-sm-3" style={{marginTop:'15px'}}>
          <h6>Field Name</h6>
        </div>
        <div className="col-sm-6" style={{marginTop:'15px'}}>
          <h6>Buddy Mapping</h6>
        </div>
        <div className="col-sm-3" style={{marginTop:'15px'}}>
          <h6>Data Preview</h6>
        </div>
        {fieldsToShow.map(field => 
        
          <div key={field} className="col-sm-12" style={{padding:'0'}}>
            <div className="col-sm-3" style={{marginTop:'15px'}}>
              {field}
            </div>
            <div className="col-sm-6" style={{marginTop:'15px'}}>

              <Select
                value={_.find(timesheetFieldOptions,{value:fieldMapping && fieldMapping[field]})}
                onChange={(selectedOption) => {

                  const newMapping = {...fieldMapping}

                  newMapping[field] = selectedOption.value;

                  getImportMapping({fieldMapping: newMapping})
                }}
                options={timesheetFieldOptions}
              /> 
              <div className="clearfix" />
            </div>
            <div className="col-sm-3" style={{marginTop:'15px'}}>
              {preview(field,fieldMapping,previewData)}
            </div>
          </div>
        )}

        <a 
        href="#" 
        className="btn btn-success"
        onClick={saveFieldMapping}
        >
          {savingMappingStatus && "Saving..." || "Save"}
        </a>
    </div>

    )

}

const mapStateToProps = (state) => {
  return {

    fieldMapping: state.timesheetImport.fieldMapping,
    // filename: state.timesheetImport.filename,
    // processingFile: state.timesheetImport.processingFile,
    fields: state.timesheetImport.fields,
    savingMappingStatus: state.timesheetImport.savingMappingStatus,
    previewData: state.timesheetImport.data && state.timesheetImport.data[0],
    // dataToSend: state.timesheetImport.dataToSend,

  }
}

const mapDispatchToProps = dispatch => ({

  getImportMapping: (payload) => dispatch(TIMESHEET_IMPORT_ACTIONS.getImportMapping(payload)),
  saveFieldMapping: (mapping) => dispatch(TIMESHEET_IMPORT_ACTIONS.saveFieldMapping(mapping)),
  
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimesheetFieldMapping) 

